<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="6" md="4" lg="4" xl="2">
        <div class="form-group">
          <label for="datepicker">Từ ngày - đến ngày</label>
          <DatePicker id="datepicker" v-model="dateRange" :model-config="dateRangeConfig"
                      :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY' }" is-range class="datepicker">
            <template v-slot="{ inputValue, inputEvents }">
              <input
                  :value="inputValue.start + ' - ' + inputValue.end"
                  v-on="inputEvents.start"
                  class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                  readonly
              />
            </template>
          </DatePicker>
        </div>
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE')">
        <BaseSelect :options="districtCodeInput.options" :data="districtCodeInput.data"
                    ref="districtCodeInput"></BaseSelect>
      </CCol>
      <CCol xs="12" sm="4" md="4" lg="4" xl="2" v-if="!$hasAuthor('ROLE_WARD')">
        <BaseSelect :options="wardCodeInput.options" :data="wardCodeInput.data" ref="wardCodeInput"></BaseSelect>
      </CCol>
      <CCol xs="12" sm="6" md="4" lg="4" xl="2">
        <BaseSelect
            :options="typeSelect.options"
            :data="typeSelect.data"
            ref="typeSelect"
        ></BaseSelect>
      </CCol>
      <CCol xs="12" sm="6" md="4" lg="4" xl="2">
        <BaseInput
            :options="titleInput.options"
            :data="titleInput.data"
            :listener="titleInput.listener"
        />
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
                style="float: right; margin-left: 5px"
                color="primary"
                v-c-tooltip.hover="'Tải lại'"
                class="btn-action-primary"
                @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp; Tải lại
            </CButton>
            <CButton
                style="float: right; margin-left: 5px"
                color="primary"
                v-c-tooltip.hover="'Thêm mới'"
                class="btn-action-primary"
                @click="$router.push('/files-screen-management/upload-screen.html')">
              <i class="fa fa-plus"></i>&nbsp; Thêm mới
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CRow class="row-2">

    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
            :options="mainTable.options"
            :slots="mainTable.slots"
            :dataSource="mainTable.dataSource"
            ref="mainTable"
        >
          <template #index="{ index }">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>

          <template #createDate="{ item }">
            <td v-if="item.createDate != null">
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
            <td v-else></td>
          </template>
          <template #description="{ item }">
            <td>
              <span :key="item.description" class="description" v-c-tooltip.hover="item.description">{{
                  item.description
                }}</span>
            </td>
          </template>
          <template #type="{ item }">
            <td>
              <span class="badge badge-light" v-if="item.type == 0 && item.isRun == true">Văn bản - Chữ chạy</span>
              <span class="badge badge-light"
                    v-else-if="item.type == 0 && item.isRun == false">Văn bản - Thông báo</span>
              <span class="badge badge-light" v-else-if="item.type == 1">Hình ảnh</span>
              <span class="badge badge-light" v-else-if="item.type == 2">Video</span>
              <span class="badge badge-light" v-else-if="item.type == 3">RSS</span>
              <span class="badge badge-light"
                    v-else-if="item.type == 4">Tài liệu / {{
                  item.url.substring(item.url.lastIndexOf(".") + 1, item.url.length)
                }}</span>
              <span class="badge badge-light" v-else-if="item.type == 5">Kênh trực tuyến</span>
            </td>
          </template>
          <template #url="{ item }">
            <td v-if="item.url != null">
              <span class="view-file" v-if="item.type != 3 && item.type != 5"
                    @click="viewFile(item.type, item.title, item.url, item.content)">Ấn vào để xem</span>
            </td>
            <td v-else></td>
          </template>
          <template #action="{ item }">
            <td class="action-btn-group">
              <div class="action-btn-wrapper">
                <CButton :disabled="item.type == 0 || item.type == 3 || item.type == 5"
                         :style="item.type == 0 || item.type == 3 || item.type == 5 ? 'cursor:no-drop' : ''"
                         color="info"
                         variant="outline"
                         v-c-tooltip.hover="'Tải xuống'"
                         square
                         size="sm"
                         @click="downloadFile(item)"
                ><i class="fa fa-download"></i>
                </CButton>
<!--                <CButton-->
<!--                    color="danger"-->
<!--                    variant="outline"-->
<!--                    square-->
<!--                    size="sm"-->
<!--                    v-c-tooltip.hover="'Xóa'"-->
<!--                    @click="setupSelectOneAction('delete_one', item.id, item.title)">-->
<!--                  <CIcon name="cil-trash"/>-->
<!--                </CButton>-->
              </div>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>

    <CModal title="Nội dung bản tin" :show.sync="isShowPopupContent" :closeOnBackdrop="false" size="lg">
      <CRow class="content-fade-in">
        <CCol md="12">
          <CForm class="form-basic">
            {{ contentDetail }}
          </CForm>
        </CCol>
      </CRow>
      <div slot="footer">
        <CButton color="secondary" class="btn-action-primary" @click="isShowPopupContent = false"><i
            class="fa fa-times"></i> Đóng
        </CButton>
      </div>
    </CModal>

    <ModalConfirm :actionTypeMapping="actionData.actionTypeMapping"
                  ref="actionModal"></ModalConfirm>

    <BaseFormLoading :loading="loading.value"></BaseFormLoading>

    <BaseModal v-if="isShowModalViewFile" :title="'Xem bản tin: ' + viewFileTitle" :show.sync="isShowModalViewFile"
               size="xl"
               :closeOnBackdrop="false">
      <template v-slot:body-wrapper>
        <div class="modal-body content-fade-in" style="max-height: 80vh;">
          <template v-if="typeViewFile == 1">
            <img :src="viewFileUrl" :alt="viewFileUrl"
                 style="width: 100%;height: 100%;max-height: 75vh;object-fit: contain">
          </template>
          <template v-else-if="typeViewFile == 2">
            <VideoPlayer style="width: 100%;height: 100%;"
                         :manifest-url="viewFileUrl"
                         :poster-url="posterUrl"/>
          </template>
          <template v-else-if="typeViewFile == 4">
            <iframe :src="viewFileUrl" frameborder="0" style="width: 100%;min-height: 75vh"></iframe>
          </template>
        </div>
      </template>
      <template v-slot:footer>
        <div slot="footer">
          <button type="button" class="btn btn-secondary" @click="isShowModalViewFile = false"
                  :disabled="loadingShareFile.value"><i
              class="fa fa-close"></i> Đóng
          </button>&nbsp;
        </div>
      </template>
    </BaseModal>
  </div>
</template>

<script>
import BaseTable from "@/views/base/BaseDataTable";
import ModalConfirm from "@/views/base/BaseModalConfirm";
import BaseInput from "@/views/base/BaseInput";
import BaseSelect from "@/views/base/BaseSelect2";
import BaseFormLoading from "@/views/base/BaseFormLoading";
import BaseModal from "@/views/base/BaseModal";
import {DatePicker} from "v-calendar";
import {USER_NAME} from '../../constant';
import VideoPlayer from "@/views/base/VideoPlayer";

export default {
  name: "ScreenFileList",
  components: {
    BaseFormLoading,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect,
    DatePicker,
    BaseModal,
    VideoPlayer
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
    },
    showWarningMsg: {
      type: "warn",
      title: "warn",
    },
  },
  data() {
    let that = this;

    let actionTypeMapping = new Map();

    actionTypeMapping.set("delete_one", {
      url: "/screen-file/delete",
      titlePopup: function () {
        return that.$helper.setupTitleAction(
            "xóa",
            "bản tin",
            that.actionData.model.fileName
        );
      },
      isJsonContentType: false,
      dataSubmit: function () {
        return {
          id: that.actionData.model.fileId,
          userName: localStorage.getItem(USER_NAME)
        };
      },
      successCallback: function () {
        that.showSuccessMsg({message: "Xóa bản tin " + that.actionData.model.fileName + " thành công"});
        that.loadDataMainTable();
      }
    });

    return {
      typeViewFile: "",
      viewFileUrl: "",
      viewFileTitle: "",
      // posterUrl: 'https://upload.wikimedia.org/wikipedia/commons/a/a7/Big_Buck_Bunny_thumbnail_vlc.png',
      posterUrl: '',
      loading: {
        value: false,
      },
      isShowModalViewFile: false,
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          selectedAll: false,
          fileId: null,
          fileName: null
        }
      },
      loadingShareFile: {value: false},
      isShowPopupShareFile: false,
      isShowPopupContent: false,
      contentDetail: "",
      dateRange: {
        start: that.$helper.subtractNowDate(7).setHours(0, 0, 0, 0),
        end: new Date().setHours(23, 59, 59, 999)
      },
      dateRangeConfig: {
        start: {
          timeAdjust: '00:00:00',
        },
        end: {
          timeAdjust: '23:59:59',
        },
      },
      titleInput: {
        options: {
          placeholder: "Tiêu đề bản tin",
          label: "Tiêu đề bản tin",
        },
        data: {
          name: "name",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      districtCodeInput: {
        options: {
          filter: true,
          label: "Quận/Huyện",
          selectAllText: "Tất cả Quận/Huyện",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: (this.$hasAuthor('ROLE_ADMIN') || this.$hasAuthor('ROLE_PROVINCE')) ? false : true
        },
        data: {
          // name: "districtCode",
          items: [],
          model: null,
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {}
            },
            response: function (dataResponse) {
              that.districtCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      wardCodeInput: {
        options: {
          filter: true,
          label: "Phường/Xã",
          selectAllText: "Tất cả Phường/Xã",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: this.$hasAuthor('ROLE_DISTRICT') ? false : true,
          disabled: this.$hasAuthor('ROLE_DISTRICT') ? false : true
        },
        data: {
          // name: "wardCode",
          model: null,
          items: [],
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                parentCode: that.districtCodeInput.data.model
              }
            },
            response: function (dataResponse) {
              that.wardCodeInput.data.items = dataResponse.data;
            }
          },
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        }
      },
      locationCode: {
        data: {
          name: 'locationCode',
          model: ''
        }
      },
      typeSelect: {
        options: {
          filter: false,
          label: "Loại bản tin",
        },
        data: {
          name: "type",
          items: [
            {key: "null", value: "Tất cả loại bản tin"},
            {key: "0", value: "Văn bản"},
            {key: "1", value: "Hình ảnh"},
            {key: "2", value: "Video"},
            {key: "3", value: "RSS"},
            {key: "4", value: "Tài liệu"},
          ],
          model: "null",
          updateTrigger: function () {
            return that.$refs.mainTable;
          },
        },
      },
      mainTable: {
        options: {
          fields: [
            {key: "index", label: "STT", sorter: false, filter: false},
            {key: "createDate", label: "Ngày tạo", _style: "max-width:5%; width:5%"},
            {key: "title", label: "Tiêu đề"},
            {key: "description", label: "Mô tả", sorter: false, filter: false},
            {key: "url", label: "Nội dung bản tin", sorter: false, filter: false},
            {key: "duration", label: "Thời lượng phát"},
            {key: "type", label: "Loại bản tin"},
            {key: "locationName", label: "Địa bàn tạo"},
            {key: "action", label: "Thao tác", sorter: false, filter: false},
          ],
          slots: [
            "index",
            "createDate",
            "action",
            "url",
            "type",
            "description"
          ],
          pageSize: 15,
          sorter: true,
          columnFilter: false,
          tableFilter: false,
          // tableFilter: {
          //   label: 'Bộ lọc: ',
          //   placeholder: 'Nhập từ khóa'
          // },
          // clickableRows: true,
          // hover: true
        },
        dataSource: {
          url: "/screen-file/getPages",
          dataSubmit: function () {
            // return that.$helper.setupDataSubmit(that.$data);
            var params = that.$helper.setupDataSubmit(that.$data);
            params.fromDate = that.$helper.formatDate(that.dateRange.start);
            params.toDate = that.$helper.formatDate(that.dateRange.end);
            return params;
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
        },
      },
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    viewFile(type, title, url, content) {
      if (type === 0) {    /* Type = 0 là dạng văn bản */
        this.isShowPopupContent = true;
        this.contentDetail = content;
      } else if (type === 1 || type === 2) {/* Type = 1 là dạng hình ảnh, Type = 2 là dạng video */
        this.typeViewFile = type;
        this.viewFileUrl = url;
        this.isShowModalViewFile = true;
      } else if (type === 4) { /* Type = 4 là dạng tài liệu */
        var fileType = url.substring(url.lastIndexOf("."), url.length);
        this.typeViewFile = type;
        // this.viewFileUrl = "https://docs.google.com/gview?url=" + url + "&embedded=true";
        this.isShowModalViewFile = true;
        if (fileType === '.pdf') {
          this.viewFileUrl = url;
        } else if (fileType === '.doc' || fileType === '.docx') {
          this.viewFileUrl = "https://view.officeapps.live.com/op/view.aspx?src=" + url;
        }
      }
      this.viewFileTitle = title;
    },
    async downloadFile(item) {
      var url;
      if (item.type == 2) {
        if (item.url && item.pathFolderFile) {
          var itemsFile = item.pathFolderFile.split("/");
          var nameFile = itemsFile[itemsFile.length - 1];
          var urlFile = item.url.substring(0, item.url.lastIndexOf("/"));
          url = urlFile + "/" + nameFile
        }
      } else {
        url = item.url;
      }
      this.loading.value = true;
      const imgUrl = await this.$helper.blobFileByUrl(url);
      this.loading.value = false;
      const a = document.createElement("a");
      document.body.appendChild(a);
      a.href = imgUrl;
      a.download = url.substring(url.lastIndexOf("/") + 1, url.length);
      a.click();
    },
    setupSelectOneAction: function (actionTypeKey, fileId, fileName) {
      let actionData = this.actionData.model;
      actionData.fileId = fileId || null;
      actionData.fileName = fileName || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    },
  },
  created: function () {
  },
  mounted() {
    if (this.$hasAuthor('ROLE_ADMIN')) {
      this.typeSelect.data.items.push({key: 5, value: 'Kênh trực tuyến'})
    }
  },
  watch: {
    dateRange: function (newValue) {
      if (newValue) {
        this.loadDataMainTable();
      } else {
        this.dateRange = {
          start: this.$helper.subtractNowDate(7).setHours(0, 0, 0, 0),
          end: new Date().setHours(23, 59, 59, 999)
        }
      }
    },
    'districtCodeInput.data.model': function (value) {
      if (value) {
        this.$refs.wardCodeInput.loadData();
        this.locationCode.data.model = value;
        this.wardCodeInput.options.disabled = false;
      } else {
        this.wardCodeInput.data.items = [];
        this.wardCodeInput.options.disabled = true;
      }
      this.wardCodeInput.data.model = null
    },
    'wardCodeInput.data.model': function (value) {
      if (value) {
        this.locationCode.data.model = value;
      } else {
        this.locationCode.data.model = this.districtCodeInput.data.model;
      }
    },
  },
  computed: {},
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
<style>
.row-2 .form-group {
  margin-top: 0 !important;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect.input-error .multiselect__tags {
  border-color: #ff7070;
}
</style>
